import { AdCampaignResult, AdCampaignResultWithContentDetail } from 'api';

export const checkHasContentDetail = (
  campaign: AdCampaignResult,
): campaign is AdCampaignResultWithContentDetail => !!campaign.contentDetail;
